import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { list, checkupSave } from "../../requests/test";
import { createSignal } from "solid-js";

export default function useCheckupTest(props) {

  const [tests, setTests] = createSignal([]);

  const [testForm, setTestForm] = createStore({
    tests: props.tests || [],
    testId: null,
  });

  const { successToast, errorToast } = useApplication();

  const addTest = () => {
    if (!testForm.testId) {
      errorToast("Please select a test");
      return;
    }

    const exist = testForm.tests.find(test => test.testId === testForm.testId);
    if (exist) {
      errorToast("Test already added");
      return;
    }

    const test = tests().find(test => test.value === testForm.testId);
    if (!test) {
      errorToast("Test not found");
      return;
    }

    const options = test.options ? test.options.split(',').map(opt => opt.trim()) : []; 

    setTestForm('tests', [...testForm.tests, {
      key: crypto.randomUUID(),
      uid: null,
      testId: testForm.testId,
      name: test.text,
      options: options,
      results: {}, // Initialize empty option values
    }]);

    setTestForm('testId', null);
  }

  const handleTestResult = (testKey, result, year) => {
    const testIndex = testForm.tests.findIndex(test => test.key === testKey);
    if (testIndex !== -1) {
      setTestForm('tests', testIndex, 'results', {
        ...testForm.tests[testIndex].results,
        [result]: year
      });
    }
  }

  const removeTest = (key) => {
    setTestForm('tests', testForm.tests.filter(test => test.key !== key));
  }

  const onFetchTests = async () => {
    try {
      const data = await list();
      setTests(data.list || []);
    } catch(error) {
      setTests([]);
    }
  }

  const onSaveTest = async () => {

    props.setLoading(true);
    try {
      const formData = new FormData();
      formData.append('tests', JSON.stringify(testForm.tests));

      const data = await checkupSave(formData);

      if (data.success) {
        successToast(data.message || "Test saved successfully");
      } else {
        errorToast(data.message || "Failed to save test");
      }
    } catch(error) {
      errorToast("Failed to save test");
    } finally {
      props.setLoading(false);
    }
  }

  const handleTestInput = (name, value) => {
    setTestForm([name], value);
  };

  return {
    tests,
    testForm,
    setTestForm,
    onSaveTest,
    handleTestInput,
    handleTestResult,
    onFetchTests,
    addTest,
    removeTest,
  };
}
